import React from 'react';

const BillIcon = ({
    width = 30,
    height = 30,
    stroke = '#0053A0',
    fill = 'white',
    className = '',
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox={`0 0 ${width} ${height}`}
            fill={fill}
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <g id="hugeicons:estimate-01">
                <path
                    id="Vector"
                    d={`M${width * 0.75} ${height * 0.3648}V${height * 0.2833}C${width * 0.75} ${height * 0.1897} ${width * 0.75} ${height * 0.1419} ${width * 0.7177} ${height * 0.1126}C${width * 0.6854} ${height * 0.0833} ${width * 0.6334} ${height * 0.0833} ${width * 0.5294} ${height * 0.0833}H${width * 0.3456}C${width * 0.2416} ${height * 0.0833} ${width * 0.1896} ${height * 0.0833} ${width * 0.1573} ${height * 0.1126}C${width * 0.125} ${height * 0.1419} ${width * 0.125} ${height * 0.1897} ${width * 0.125} ${height * 0.2833}V${height * 0.55}C${width * 0.125} ${height * 0.7443} ${width * 0.125} ${height * 0.7914} ${width * 0.1573} ${height * 0.8207}C${width * 0.1896} ${height * 0.85} ${width * 0.2416} ${height * 0.85} ${width * 0.3456} ${height * 0.85}H${width * 0.5294}M${width * 0.25} ${height * 0.25}H${width * 0.625}M${width * 0.25} ${height * 0.4167}H${width * 0.2917}M${width * 0.4167} ${height * 0.4167}H${width * 0.4583}M${width * 0.5833} ${height * 0.4167}H${width * 0.625}M${width * 0.25} ${height * 0.5833}H${width * 0.2917}M${width * 0.4167} ${height * 0.5833}H${width * 0.4583}M${width * 0.8628} ${height * 0.6252}C${width * 0.8513} ${height * 0.5962} ${width * 0.8219} ${height * 0.5623} ${width * 0.755} ${height * 0.5623}C${width * 0.6773} ${height * 0.5623} ${width * 0.6445} ${height * 0.5979} ${width * 0.6379} ${height * 0.6169}C${width * 0.6275} ${height * 0.6424} ${width * 0.6265} ${height * 0.6973} ${width * 0.7208} ${height * 0.7005}C${width * 0.8333} ${height * 0.7042} ${width * 0.8803} ${height * 0.7195} ${width * 0.8745} ${height * 0.7812}C${width * 0.8687} ${height * 0.8428} ${width * 0.8039} ${height * 0.8514} ${width * 0.755} ${height * 0.8548}C${width * 0.7048} ${height * 0.8533} ${width * 0.6427} ${height * 0.8428} ${width * 0.625} ${height * 0.7895}M${width * 0.7498} ${height * 0.5}V${height * 0.5598}M${width * 0.7501} ${height * 0.8545}V${height * 0.9167}`}
                    stroke={stroke}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </svg>
    );
};

export default BillIcon;
